import { useEffect, useState } from "react";
import api, { formatApiError } from "@/lib/api";
import { Textarea } from "@/components/ui/textarea";
import { toast } from "sonner";
import { Camera, CheckCircle2 } from "lucide-react";

const KINDS = [["photos", "Photos"], ["video", "Vidéo"], ["both", "Photos + vidéo"]];

export default function MediaRequestBox({ businessTitle, onRequested }) {
  const [open, setOpen] = useState(false);
  const [kind, setKind] = useState("both");
  const [message, setMessage] = useState("");
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(null);

  useEffect(() => {
    api.get("/seller/media-requests").then(({ data }) => { const m = data.find((x) => x.business_title === (businessTitle || "")); if (m) { setSent(m); onRequested?.(); } }).catch(() => {});
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const submit = async () => {
    setBusy(true);
    try {
      const { data } = await api.post("/seller/media-requests", { kind, message, business_title: businessTitle || "" });
      setSent(data); setOpen(false); onRequested?.();
      toast.success("Demande envoyée : PROAC Transmission vous recontacte pour organiser la prise de vue.");
    } catch (e) { toast.error(formatApiError(e.response?.data?.detail)); }
    setBusy(false);
  };

  if (sent) return (
    <div data-testid="media-request-sent" className="flex items-start gap-2 bg-emerald-50 border border-emerald-200 p-3 text-sm text-emerald-800">
      <CheckCircle2 className="w-4 h-4 mt-0.5 shrink-0" /> Demande de {KINDS.find(([k]) => k === sent.kind)?.[1].toLowerCase()} envoyée le {new Date(sent.created_at).toLocaleDateString("fr-FR")}. Vous pouvez continuer sans image : PROAC Transmission s'occupe des visuels.
    </div>
  );
  return (
    <div className="border border-dashed border-[#E0C173] bg-[#F8F6F0] p-4 text-sm" data-testid="media-request-box">
      <div className="flex flex-wrap items-center justify-between gap-3">
        <span className="text-[#1B2A4A]">Pas de photos ou de vidéo ? PROAC Transmission peut les réaliser pour vous.</span>
        {!open && <button type="button" data-testid="media-request-open" onClick={() => setOpen(true)} className="inline-flex items-center gap-1.5 bg-[#1B2A4A] text-white px-4 py-2 text-xs"><Camera className="w-4 h-4" /> Demander à PROAC</button>}
      </div>
      {open && (
        <div className="mt-3 space-y-3">
          <div className="flex flex-wrap gap-2">
            {KINDS.map(([k, l]) => <button type="button" key={k} data-testid={`media-kind-${k}`} onClick={() => setKind(k)} className={`px-3 py-1.5 text-xs border rounded-full ${kind === k ? "bg-[#1B2A4A] text-white border-[#1B2A4A]" : "border-gray-300 text-[#475569] bg-white"}`}>{l}</button>)}
          </div>
          <Textarea data-testid="media-request-message" value={message} onChange={(e) => setMessage(e.target.value)} rows={2} placeholder="Disponibilités, lieux à photographier…" className="rounded-none border-gray-300 bg-white" />
          <button type="button" data-testid="media-request-submit" onClick={submit} disabled={busy} className="bg-[#E0C173] hover:bg-[#C9A85A] text-[#1B2A4A] font-semibold px-4 py-2 text-xs disabled:opacity-50">{busy ? "Envoi…" : "Envoyer la demande"}</button>
        </div>
      )}
    </div>
  );
}
